// Keys match the C# TextMessageTemplates PascalCase property names exactly
export const notificationTypeLabels: Record<string, string> = {
    NPC: "NPC",
    NPCOverLimit: "NPC Over Limit",
    NPCOrderCreated: "NPC Order Created",
    Refill: "Refill",
    RxRequestDenied: "Rx Request Denied",
    OutOfNetwork: "Out of Network",
    Autorefill: "Auto Refill",
    AutorefillDelay: "Auto Refill Delayed",
    Transfer: "Transfer",
    Shipping: "Shipping",
    PartialPayment: "Partial Payment",
    PartialPaymentOverLimit: "Partial Payment Over Limit",
    AwaitingInsurance: "Awaiting Insurance",
    PharmacyInfo: "Pharmacy Info",
    ReadyForPickup: "Ready for Pickup",
    DeliveryConfirmation: "Delivery Confirmation",
    PatientAssistanceProgram: "Patient Assistance Program",
};
